import { render, staticRenderFns } from "./ElectronTechnology.vue?vue&type=template&id=c05f3870&scoped=true"
import script from "./ElectronTechnology.vue?vue&type=script&lang=js"
export * from "./ElectronTechnology.vue?vue&type=script&lang=js"
import style0 from "./ElectronTechnology.vue?vue&type=style&index=0&id=c05f3870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05f3870",
  null
  
)

export default component.exports